import React from 'react'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd'
import Layout from './layout'

function DragAndDrop({ id, index, onMove, onDrop, itemType, children, className }) {
  return (
    <DndProvider backend={HTML5Backend}>
      <Layout
        id={id}
        index={index}
        onMove={onMove}
        onDrop={onDrop}
        className={className}
        itemType={itemType}
      >
        {children}
      </Layout>
    </DndProvider>
  )
}

export default DragAndDrop
